import { Divider, Typography } from '@mui/material';
import type { FC, PropsWithChildren, ReactNode } from 'react';

import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

interface VrsCallCommentsBasePopupProps {
  icon: ReactNode;
  title: string;
  subtitle: string;
  containerTitle?: string;
  badge?: ReactNode;
}

export const VrsCallCommentsBasePopup: FC<
  PropsWithChildren<VrsCallCommentsBasePopupProps>
> = ({ children, icon, title, subtitle, containerTitle, badge }) => {
  return (
    <Container>
      <IconContainer>{icon}</IconContainer>
      <Typography
        variant='h1'
        color={theme.palette.common.white}
        align='center'
        mt={12}
      >
        {title}
      </Typography>
      <Typography variant='body1' color={theme.palette.grey[50]} mt={16}>
        {subtitle}
      </Typography>
      {containerTitle && (
        <>
          <StyledContainer>
            <Typography variant='h2' color={theme.palette.common.white}>
              {containerTitle}
            </Typography>
            {badge}
          </StyledContainer>
          <Separator title='bug-report-divider' />
        </>
      )}
      {children}
    </Container>
  );
};

const Container = styled('div')`
  width: 550px;
  display: flex;
  flex-direction: column;
  background-color: ${theme.palette.grey[900]};
  border-radius: 8px;
  padding: ${theme.spacing(31, 23, 23)};
`;

const IconContainer = styled('div')`
  height: 60px;
  text-align: center;
`;

const StyledContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-top: ${theme.spacing(16)};
`;

const Separator = styled(Divider)`
  border-color: ${theme.palette.grey[600]};
  margin: ${theme.spacing(8, 0)};
`;
